import { render, staticRenderFns } from "./YellowCirclePicture.vue?vue&type=template&id=b28835e4&scoped=true&"
import script from "./YellowCirclePicture.vue?vue&type=script&lang=js&"
export * from "./YellowCirclePicture.vue?vue&type=script&lang=js&"
import style0 from "./YellowCirclePicture.vue?vue&type=style&index=0&id=b28835e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28835e4",
  null
  
)

export default component.exports